import { USER_ROLE } from "Constants/constant";
import { roleAccess } from "helpers/RolesPermission";
import {
  isGhostSessionActive,
  isPlatformTenantContextActive,
} from "context/platformAdminContext.utils";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";

export const isNativePlatformAdminView = () =>
  roleAccess([USER_ROLE.Super_Admin]) &&
  !isPlatformTenantContextActive() &&
  !isGhostSessionActive();

export const getPlatformFormsMeta = (routeRole) => {
  const isHrm = routeRole === "hrm";

  return {
    title: isHrm ? "Forms — HRM" : "Forms — CRM",
    subtitle: isHrm
      ? "Platform-wide HRM form templates"
      : "Platform-wide CRM form templates",
    createPath: isHrm ? "/hrm/create-new-report" : "/crm/create-new-report",
    createLabel: isHrm ? "Create HRM form" : "Create CRM form",
    permissionName: isHrm ? PERMISSION_KEYS.HRM_FORM : PERMISSION_KEYS.CRM_FORM,
    createPermission: isHrm
      ? PERMISSION_KEYS_CHILDREN.HRM_FORM.CREATE
      : PERMISSION_KEYS_CHILDREN.CRM_FORM.CREATE,
  };
};

export const getFormStatusLabel = (queryParams) => {
  const status = queryParams?.status ?? queryParams?.filter?.status;

  if (status === "publish") {
    return "Published";
  }

  if (status === "hidden") {
    return "Hidden";
  }

  if (status === "draft") {
    return "Draft";
  }

  return "All Status";
};

export const getFormRowStatusBadge = (row, activeStatus) => {
  if (row?.is_hidden) {
    return { label: "Hidden", variant: "warning" };
  }

  const status = activeStatus ?? row?.status;

  if (status === "publish" || status === "published") {
    return { label: "Published", variant: "success" };
  }

  if (status === "hidden") {
    return { label: "Hidden", variant: "warning" };
  }

  return { label: "Draft", variant: "neutral" };
};
